import * as ActionTypes from "./actionTypes";
export const setLocalStoreAction = (localStore) => {
    return {
        type: ActionTypes.SET_LOCAL_STORE,
        payload: localStore,
    };
};
export const setLocalStoreItemAction = (id, localStoreItem) => {
    return {
        type: ActionTypes.SET_LOCAL_STORE_ITEM,
        payload: {
            localStoreItem,
            id,
        },
    };
};
export const setGlobalStoreAction = (globalStore) => {
    return {
        type: ActionTypes.SET_GLOBAL_STORE,
        payload: globalStore,
    };
};
export const resetGlobalStoreAction = {
    type: ActionTypes.RESET_GLOBAL_STORE,
};
export const setProfileAction = (profile) => {
    return {
        type: ActionTypes.SET_PROFILE,
        payload: profile,
    };
};
export const setFiltersAction = (id, filters) => {
    return {
        type: ActionTypes.SET_FILTERS,
        payload: {
            filters,
            id,
        },
    };
};
export const setTableSettingsAction = (id, tableSettings) => {
    return {
        type: ActionTypes.SET_TABLE_SETTINGS,
        payload: {
            tableSettings,
            id,
        },
    };
};
export const resetProfileAction = {
    type: ActionTypes.RESET_PROFILE,
};
export const logOutAction = {
    type: ActionTypes.LOG_OUT,
};
export const changeLocationAction = {
    type: ActionTypes.CHANGE_LOCATION,
};
//# sourceMappingURL=index.js.map